import React from "react";
import { FaStore, FaGlobe } from "react-icons/fa";
import "./SoWByPersonaSection.css";
import { MdTempleBuddhist as FaTemple } from "react-icons/md";

const SoWByPersonaSection = () => {
    return (
        <section className="_sPSec_v1A_">
            <div className="_sPCont_w2B_" style={{ paddingBottom: "0", marginBottom: "0" }}>
                <h2 className="_pSTitle_x3C_" style={{ paddingBottom: "1.3rem", marginBottom: "1.8rem" }}>
                    SoW Expectations by User Persona
                </h2>

                <div className="_pCGrid_y4D_ workflow-cards-wrapper">

                    {/* COMMUNITIES / GROUPS */}
                    <div className="temple-card workflow-card">
                        <div className="card-icon-wrapper">
                            <FaTemple className="card-icon" />
                        </div>
                        <h3 className="card-title">Communities & Groups</h3>
                        <ul className="_pCList_e0J_">
                            <li>
                                <strong>Product Preferences:</strong> Provide clarity on Satvik, organic, or ritual-specific requirements for catalog curation.
                            </li>
                            <li>
                                <strong>Verification Support:</strong> Help validate local sellers where needed, ensuring authenticity and quality.
                            </li>
                            <li>
                                <strong>Event Coordination:</strong> Share schedules for festivals or group needs to enable smooth bulk deliveries.
                            </li>
                            <li>
                                <strong>Communication Flow:</strong> Assign a point of contact for order issues, escalations, or logistics questions.
                            </li>
                            <li>
                                <strong>Privacy & Ethics:</strong> Handle member data responsibly and align with Vanidya’s data protection policies.
                            </li>
                            <li>
                                <strong>Feedback Loop:</strong> Participate in catalog reviews, service evaluations, and continuous improvement discussions.
                            </li>
                        </ul>
                    </div>

                    {/* SELLERS */}
                    <div className="temple-card workflow-card">
                        <div className="card-icon-wrapper">
                            <FaStore className="card-icon" />
                        </div>
                        <h3 className="card-title">Sellers</h3>
                        <ul className="_pCList_e0J_">
                            <li>
                                <strong>Onboarding:</strong> Complete verification, upload catalog, pricing, and product details accurately.
                            </li>
                            <li>
                                <strong>Order Fulfilment:</strong> Meet packaging, hygiene, delivery timelines, and product freshness standards.
                            </li>
                            <li>
                                <strong>Quality & Compliance:</strong> Adhere to Satvik/organic product claims, ingredient transparency, and safety norms.
                            </li>
                            <li>
                                <strong>Returns & Replacements:</strong> Follow platform policies for resolving defective or incorrect deliveries.
                            </li>
                            <li>
                                <strong>Customer Experience:</strong> Ensure timely communication, courteous service, and resolution of complaints within SLA.
                            </li>
                            <li>
                                <strong>Catalog Maintenance:</strong> Keep inventory updated, avoid stock-outs, and revise product info as needed.
                            </li>
                        </ul>
                    </div>

                    {/* VANIDYA PLATFORM */}
                    <div className="temple-card workflow-card">
                        <div className="card-icon-wrapper">
                            <FaGlobe className="card-icon" />
                        </div>
                        <h3 className="card-title">Vanidya Platform</h3>
                        <ul className="_pCList_e0J_">
                            <li>
                                <strong>Platform Reliability:</strong> Maintain uptime, fast loading, secure checkout, and stable ordering flows as per SLA.
                            </li>
                            <li>
                                <strong>Safe Transactions:</strong> Ensure secure payment methods and transparent reconciliation workflows.
                            </li>
                            <li>
                                <strong>Operational Support:</strong> Provide multi-channel support (email, chat, phone) with trackable SLA-based resolution.
                            </li>
                            <li>
                                <strong>Policy & Governance:</strong> Enforce quality checks, listing rules, privacy policies, and regulatory compliance.
                            </li>
                            <li>
                                <strong>Reporting & Insights:</strong> Offer data dashboards, service metrics, and periodic reviews for sellers and partners.
                            </li>
                            <li>
                                <strong>Continuous Improvement:</strong> Deliver regular platform enhancements, feature updates, and partner enablement materials.
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default SoWByPersonaSection;